namespace khi.bk117.event
{
	import Event = com.enirva.event.Event;

	/*
	 * ViewEvent
	 */
	export class ControllerEvent extends Event
	{
		public static CHANGE_BG:string = "changeBg";
		
		public static CHANGE_NAVI:string = "changeNavi";

		public static RE_SET_PJAX:string = "reSetPjax";

		public static CLICK_SLIDE_AREA:string = "clickSlideArea";

		public static FIRST_MOVE:string = "firstMove";

		public href:string;

		public targetElm:JQuery;

		public colorType:string;

		public naviIndex:number;

		//カルーセルエリアクリック用
		public target:JQuery;
		public nextAddIndex:number;
		
		constructor(type:string)
		{
			super(type);
		}
	}
}

